import { http } from '@/core/api/';
import _ from 'lodash';
import academicYearService from '../common/academicyear.api';
const apiUrl = 'api/studentimpediment';
const apiCompuUrl = 'api/compuappointment';

export default {
  //Filters
  async fetchCompuAcademicYears(studentSieId) {
    return await academicYearService.getPlacementCommitteeAdemicYear(
      studentSieId
    );
  },
  async fetchCompuMeetingTypes() {
    const { status, data: response } = await http.get(
      `${apiCompuUrl}/compumeetingtypes`
    );
    return status !== 200 ? {} : response;
  },
  //Search
  async fetchStudentCompuHistory(filter, perPage) {
    let response = await http.get(
      `${apiUrl}/studentimpedimenttranhistory/${filter.studentSieId}`,
      {
        params: filter,
      }
    );

    if (response.data) {
      return _.chunk(response.data, perPage);
    }
    return [];
  },

  async canUpdateImpedimentInfo(studentSieId) {
    return await http.get(
      `${apiUrl}/canupdateelegibilityimpediment/${studentSieId}`
    );
  },

  async updateImpedimentInfo(studentSieId) {
    return await http.post(`${apiUrl}/updateimpedimentinfo/${studentSieId}`);
  },
};
